"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getIsHostAppContextPrivate = exports.getUploadedFileAccess = exports.getUseEsFileSearch = exports.getHostApp = exports.getSpecificCanvaTemplates = exports.getIsCanvaEnabled = exports.getIsShutterstockEnabled = void 0;

var _reselect = require("reselect");

var _PrivateContextBenderProjectList = _interopRequireDefault(require("../enums/PrivateContextBenderProjectList"));

var _Auth = require("FileManagerCore/selectors/Auth");

var getConfiguration = function getConfiguration(state) {
  return state.configuration;
};

var getIsShutterstockEnabled = (0, _reselect.createSelector)([getConfiguration], function (configuration) {
  return configuration.get('withShutterstock') === true;
});
exports.getIsShutterstockEnabled = getIsShutterstockEnabled;
var getIsCanvaEnabled = (0, _reselect.createSelector)([getConfiguration], function (configuration) {
  return configuration.get('withCanva') === true;
});
exports.getIsCanvaEnabled = getIsCanvaEnabled;
var getSpecificCanvaTemplates = (0, _reselect.createSelector)([getConfiguration], function (configuration) {
  return configuration.get('specificCanvaTemplates');
});
exports.getSpecificCanvaTemplates = getSpecificCanvaTemplates;
var getHostApp = (0, _reselect.createSelector)([getConfiguration], function (configuration) {
  return configuration.get('hostApp');
});
exports.getHostApp = getHostApp;
var getUseEsFileSearch = (0, _reselect.createSelector)([_Auth.getIsUngatedForBypassElasticSearch], function (isBypassUngated) {
  return !isBypassUngated;
});
exports.getUseEsFileSearch = getUseEsFileSearch;
var getUploadedFileAccess = (0, _reselect.createSelector)([getConfiguration], function (configuration) {
  return configuration.get('uploadedFileAccess');
});
exports.getUploadedFileAccess = getUploadedFileAccess;
var getIsHostAppContextPrivate = (0, _reselect.createSelector)([getHostApp], function (hostApp) {
  return _PrivateContextBenderProjectList.default.includes(hostApp);
});
exports.getIsHostAppContextPrivate = getIsHostAppContextPrivate;